import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { yahooService } from '../services/yahoo-service';

const YahooCallback = () => {
  const navigate = useNavigate();
  const { loginYahoo } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError(`Access denied: ${errorParam}`);
      return;
    }

    if (code) {
      const handleLogin = async () => {
        try {
          const { access_token } = await yahooService.exchangeCodeForToken(code, state);
          loginYahoo(access_token);
          
          if (state) {
            navigate(`/profile/config/${state}`);
          } else {
            navigate('/profile');
          }
        } catch (err: any) {
          console.error('Yahoo login failed:', err);
          setError(err.message || 'Failed to authenticate with Yahoo.');
        }
      };
      handleLogin();
    } else {
      setError('No authorization code found in the redirect URL.');
    }
  }, [loginYahoo, navigate]);

  if (error) {
    const searchParams = new URLSearchParams(window.location.search);
    const state = searchParams.get('state');
    const returnPath = state ? `/profile/config/${state}` : '/profile';

    return (
      <div className="container profile-page">
        <div className="auth-card-container">
          <div className="auth-card">
            <div className="auth-card-icon error">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <h1 className="auth-card-title">Yahoo Login Failed</h1>
            <p className="auth-card-subtitle">
              We couldn't complete authentication with Yahoo Fantasy Sports.
            </p>
            <p className="error-message">{error}</p>
            <div className="auth-card-actions">
              <button onClick={() => navigate(returnPath)} className="btn btn-primary">
                {state ? 'Return to Guild Settings' : 'Return to Profile'}
              </button>
              {state && (
                <button onClick={() => navigate('/profile')} className="btn btn-secondary">
                  Back to Profile
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container profile-page">
      <div className="auth-card-container">
        <div className="auth-card">
          <div className="auth-card-icon loading">
            <svg className="spinner-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
            </svg>
          </div>
          <h1 className="auth-card-title">Authenticating with Yahoo...</h1>
          <p className="auth-card-subtitle">Please wait while we connect your Yahoo account.</p>
        </div>
      </div>
    </div>
  );
};

export default YahooCallback;
